import React from 'react';
import { Modal, Descriptions, Typography, Space } from 'antd';
import { FileProtectOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ActionButton, SignaturePreview } from '../styled';

const { Title, Text } = Typography;

const RegistrationWaiverModal = ({
  registrationWaiverModal,
  onClose
}) => {
  const registration = registrationWaiverModal.registration;

  return (
    <Modal
      title={
        <span>
          <FileProtectOutlined style={{ marginRight: 8 }} />
          Volunteer Waiver - {registration?.fullName}
        </span>
      }
      open={registrationWaiverModal.visible}
      onCancel={onClose}
      footer={[
        <ActionButton key="close" onClick={onClose}>
          Close
        </ActionButton>
      ]}
      width={700}
    >
      {registration && (
        <div>
          <Descriptions 
            bordered 
            size="small" 
            column={1}
            style={{ marginBottom: 16 }}
          >
            <Descriptions.Item label="Volunteer Name">
              <strong>{registration.fullName}</strong>
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {registration.email}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {registration.phoneNumber || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Location">
              {registration.preferredCity 
                ? `${registration.preferredCity}, ${registration.preferredState || ''}`.trim()
                : (registration.isGeneralVolunteer ? 'Any Location' : '-')
              }
            </Descriptions.Item>
            <Descriptions.Item label="Volunteer Area">
              {registration.volunteerArea || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Medical Experience">
              {registration.medicalExperience || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Waiver Version">
              {registration.waiverVersion || '1.0'}
            </Descriptions.Item>
            <Descriptions.Item label="Signed At">
              {registration.waiverSignedAt 
                ? new Date(registration.waiverSignedAt).toLocaleString()
                : '-'
              }
            </Descriptions.Item>
            <Descriptions.Item label="Printed Name">
              {registration.printedName || '-'}
            </Descriptions.Item>
          </Descriptions>
          
          <Title level={5} style={{ marginTop: 16, marginBottom: 8 }}>
            Acknowledgment
          </Title>
          {(() => {
            const isAcknowledged = registration.acknowledgedWaiver || registration.acknowledgedRisks;
            return (
              <div style={{ 
                padding: '12px', 
                background: isAcknowledged ? '#f6ffed' : '#fff2f0',
                border: `1px solid ${isAcknowledged ? '#b7eb8f' : '#ffa39e'}`,
                borderRadius: '6px',
                marginBottom: 16
              }}>
                <Space>
                  {isAcknowledged ? (
                    <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 18 }} />
                  ) : (
                    <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: 18 }} />
                  )}
                  <Text>
                    Volunteer has {isAcknowledged ? '' : 'NOT '}acknowledged the waiver terms and conditions
                  </Text>
                </Space>
              </div>
            );
          })()}
          
          <Title level={5} style={{ marginTop: 16, marginBottom: 8 }}>
            Signature
          </Title>
          <SignaturePreview>
            {registration.signatureType === 'draw' && registration.signatureData ? (
              <img 
                src={registration.signatureData} 
                alt="Signature" 
              />
            ) : registration.typedSignature ? (
              <div className="typed-signature">
                {registration.typedSignature}
              </div>
            ) : (
              <Text type="secondary">No signature available</Text>
            )}
          </SignaturePreview>
        </div>
      )}
    </Modal>
  );
};

export default RegistrationWaiverModal;
